import React, { FunctionComponent } from 'react';
import { ResponsiveLine } from '@nivo/line';
import SliceTooltip from '../slice-tooltip/slice-tooltip';
import { Serie } from '@nivo/line';
import DefaultLineChart from '../default-line-chart';

type StatsGlobalSolicitationsContainerProps = {
  data: Serie[];
};

const SolicitationsGraphView: FunctionComponent<
  StatsGlobalSolicitationsContainerProps
> = ({ data }) => {
  return <DefaultLineChart data={data} colors={['#EF8400', '#FFD3B5']} />;
};
export default SolicitationsGraphView;
